module.exports = __webpack_public_path__ + "static/media/ico_search.78642fb1.svg";